import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/empty.svg'
import _imports_1 from '@/assets/images/result-empty.svg'


const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center w-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "empty topics",
  class: "w-[90vw] md:w-[37vw]"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col items-center justify-center w-full mt-14"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "empty results",
  class: "w-[37vw] md:w-[8vw] min-w-[136px]"
}, null, -1)
const _hoisted_7 = { class: "w-[80vw] md:w-full text-center text-base gap-2 flex flex-col mt-4 text-h-neutral-700 justify-center items-center" }
const _hoisted_8 = { class: "font-extrabold" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = {
  key: 2,
  class: "sm:w-[90vw] md:w-full sm:max-w-[640px] md:max-w-[100vw] flex flex-col items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopicCard = _resolveComponent("TopicCard")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.totalTopics === 0 && !_ctx.$route.query.title)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_4))
      : (_ctx.$route.query.title && _ctx.totalTopics === 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", { pt: "Sem resultados", en: "No results" })), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Não foram encontrados tópicos com o termo pesquisado.",
              en: "No topics were found with the search term.",
            })), 1)
            ]),
            _createElementVNode("button", {
              class: "border btn-outline min-w-[143px] rounded font-bold h-8 w-[39vw] md:w-[9.9vw] mt-6 cursor-pointer flex items-center justify-center text-base mb-32",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
            }, _toDisplayString(_ctx.$t("labels.generic", { pt: "Limpar pesquisa", en: "Clean search" })), 1)
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topics, (topic) => {
              return (_openBlock(), _createBlock(_component_TopicCard, {
                topic: topic,
                class: "mx-4 mb-6"
              }, null, 8, ["topic"]))
            }), 256)),
            _createVNode(_component_Paginator, {
              totalRecords: _ctx.totalTopics,
              rows: _ctx.numberOfTopicsPerPage,
              value: _ctx.topics,
              first: _ctx.getFirstItemIndexActualPage(),
              onPage: _ctx.onPaginate,
              pageLinkSize: 3,
              class: "mb-16 md:w-full w-fit md:flex md:right-0 md:justify-end custom-paginator-forum"
            }, null, 8, ["totalRecords", "rows", "value", "first", "onPage"])
          ]))
  ]))
}